import { Domain } from "./domain";
import { Country } from "./country";
import { ClickUrl } from "./clickUrl";

export class VideoCreativeStats {
    countries: Country[] = [];
    domains: Domain[] = [];
    clickUrls: ClickUrl[] = [];
}